import { collections } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          align="center"
          kicker="编辑精选"
          title="精选合集 · 编辑部严选"
          desc="把分散在事件里的高光画面重新编排成主题合集，适合一口气看完的「最佳图集」，也方便收藏反复回味。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {collections.map((c) => (
            <article
              key={c.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 cursor-pointer"
              onClick={() =>
                window.dispatchEvent(new CustomEvent("chigua:toast", { detail: `正在打开「${c.title}」精选合集…` }))
              }
            >
              <div className="grid grid-cols-[1fr_auto] gap-0">
                <div className="relative aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={c.cover}
                    alt={`${c.title}精选合集封面大图`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-[11px] font-semibold text-background-50 bg-accent-500 whitespace-nowrap">
                    {c.tag}
                  </span>
                  <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                </div>
                <div className="hidden sm:block w-28 md:w-40 lg:w-48 relative overflow-hidden">
                  <img
                    src={c.subImg}
                    alt={`${c.title}合集子图预览`}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-background-50/10"></div>
                </div>
              </div>

              <div className="p-4 md:p-5 flex items-end justify-between gap-3">
                <div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug">{c.title}</h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600">{c.sub}</p>
                </div>
                <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500">
                  <i className="ri-image-2-line text-primary-600"></i>
                  {c.pics} 张
                </span>
              </div>
              <div className="px-4 md:px-5 pb-4 md:pb-5 flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i> {c.views} 次浏览
                </span>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all whitespace-nowrap">
                  收藏合集 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}